import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@/components/General/ContentCard/contentCard.component"
    ).then((module) => ({
        default: module.ContentCard
    }))
);
